import { render, staticRenderFns } from "./RelatorioExportacaoUsuario.vue?vue&type=template&id=b2aacc12"
import script from "./RelatorioExportacaoUsuario.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacaoUsuario.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacaoUsuario.vue?vue&type=style&index=0&id=b2aacc12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports